import "@/styles/packages.scss"
import { register } from "../helpers/stimulus"

import AccordionController from "../controllers/accordion_controller"
import CarouselController from "../controllers/carousel_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import TooltipController from "../controllers/tooltip_controller"
import VoucherFormController from "../controllers/voucher_form_controller"

const setupStimulus = (): void => {
  register("accordion", AccordionController)
  register("carousel", CarouselController)
  register("package-details-modal", ModalController)
  register("package-details-modal-trigger", ModalTriggerController)
  register("tooltip", TooltipController)
  register("voucher-form", VoucherFormController)
}

setupStimulus()
